import { useEffect, useState } from 'react';
import { Map } from 'mapbox-gl';
import { PredefinedTemplate } from 'types';

import {
  changeViewBox,
  getTypeIcons,
  loadSvgStringAsImagePromise,
} from 'utils';

// We load our SVG as 37x37 with 0 0 37 37 viewBox to ensure it's the same px size as markers,
// otherwise it doesn't overlay correctly with markers. We change viewBox so that actual rendered parts stay small
export const useLoadEntityTypeImages = (
  mapObjectTemplate: PredefinedTemplate,
  map: Map | null
) => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    if (mapObjectTemplate && map && !init) {
      setInit(true);
      const typeIcons = getTypeIcons(mapObjectTemplate);

      typeIcons.forEach((icon) => {
        if (map?.hasImage(icon.Name)) return;
        loadSvgStringAsImagePromise({
          svgString: changeViewBox(icon.Svg, '0 0 37 37'),
          width: 37,
          height: 37,
        }).then((res) => map?.addImage(icon.Name, res));
      });
    }
  }, [mapObjectTemplate, map, init]);
};
